<container-padrao>
    <card title="Autocadastros">

        <div class="mb-3">
            <primary-button (click)="onClickCriarAutocadastro()">Criar autocadastro</primary-button>
        </div>
        
        <tabela-listagem
            #listaAutocadastro
            [colunas]="colunasListar"
            [service]="autocadastroService"
            [actions]="actionsTabelaAutocadastro"
        ></tabela-listagem>
    </card>
</container-padrao>

<modal #modalAutocadastro [data]="modalAutocadastroData" [onSave]="onSalvarAutocadastro">
    <formulario-dinamico
        *ngIf="exibirModal"
        #formularioAutocadastro
        [colunas]="colunasModal"
        [entidade]="autocadastro"
    ></formulario-dinamico>

    <div class="mt-3 d-flex" *ngIf="urlautocadastroClipboard">
        <div style="width: 80%;">
            <code>{{urlautocadastroClipboard}}</code>
        </div>
        <div style="width: 20%">
            <button-component (click)="copiarParaClipboard(urlautocadastroClipboard)" icon="content_copy"></button-component>
        </div>
    </div>
</modal>

<modal #modalQrCode [data]="modalQrCodeData" [showBtnConfirmar]="false" [showBtnCancelar]="false">
    <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="exibirModalQrCode && qrCodeUrl">
        <img class="qr-code-imagem mb-3" [src]="qrCodeUrl" alt="QR Code do autocadastro">
        <button-component (click)="baixarQrCode()" icon="download" text="Baixar QR Code"></button-component>
    </div>
</modal>